// const digitPeriodRegExp = /\d|\./

export function blockInvalidChar (event) {
  if (event.ctrlKey || event.altKey || typeof event.key !== 'string' || event.key.length !== 1) {
    return
  }

  if (!/[\d.]/.test(event.key)) {
    event.preventDefault()
    return
  }

  if (event.key === '.' && event.target.value.includes('.')) {
    event.preventDefault()
  }
}

export const blockInvalidCharInInputNumberField = e => {
  ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()
}
